import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.53 4.387a.75.75 0 0 1 0 1.06L5.366 19.614a.75.75 0 1 1-1.061-1.061L18.47 4.387a.75.75 0 0 1 1.06 0"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.305 4.387a.75.75 0 0 1 1.06 0L19.53 18.552a.75.75 0 0 1-1.06 1.06L4.305 5.449a.75.75 0 0 1 0-1.06"/>' }
  })
);